module.exports = __webpack_public_path__ + "static/img/Type_Badge_Properties_White.f07de65.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Type_Badge_Properties_White.png
// module id = 3tNs
// module chunks = 28